import React from 'react';
import './LocalImage.css';



const LocalImage = () => {
  return (
    <>
    <div className="local-image-section">
      
    </div>
    
   </>
  );
};


export default LocalImage;
